// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_AkS","cls2":"LoswpExitIntentModal-cls2_XtX LoswpExitIntentModal-cls1_AkS"};